module.exports = __webpack_public_path__ + "img/ifeanyi.a20c27ca.png";